import {
  Column,
  Container,
  Horizontal,
  Row,
  Title
} from '@smuchile/pkg-unimarc-components'
import {
  useContentful,
  useMobile,
  useProductsSearch
} from '@smuchile/pkg-unimarc-hooks'
import { Shelves } from 'components'
import { useEffect, useState } from 'react'
import { paginationCal } from 'shared/helpers/paginationCal'
import { LiveShopingBackbone } from './LiveShopingBackbone'

export const LiveShoping = () => {
  const [isLoading, setIsLoading] = useState(true)
  const { innerWidth } = useMobile()
  const { offset, end } = paginationCal({ page: 0, limit: 50 })
  const contentFields = useContentful({
    options: {
      content_type: 'home',
      'sys.id[in]': '6y30mcmwu6EsniC2vkCF3N'
    }
  }).data?.['includes']?.Entry[0]?.fields
  const formattedOffset = Math.abs(offset).toString()
  const formattedEnd = Math.abs(end).toString()
  const formattedClusterId = contentFields?.idCollection
    .match(/\d+/)[0]
    .toString()
  const { liveTitle, liveSubtitle } = {
    liveTitle: contentFields?.title,
    liveSubtitle: contentFields?.subTitle
  }

  const productsByCategory = useProductsSearch({
    clusterId: formattedClusterId,
    from: formattedEnd,
    to: formattedOffset
  })

  const src = contentFields?.html
    ?.split('src="')[1]
    ?.split('%22%3E')[0]
    ?.split('"></script>')[0]
  const isMobile = innerWidth < 1280
  const columnMaxWidth = isMobile ? '92%' : '1120px'
  const products = productsByCategory?.data?.availableProducts

  const callNizzaStream = () => {
    const script = document.createElement('script')
    script.src = src
    script.id = 'nizza-player-script'
    script.type = 'module'

    document.body.appendChild(script)
  }

  useEffect(() => {
    if (!products) return

    setIsLoading(false)
    callNizzaStream()
  }, [products])

  if (isLoading) {
    return (
      <Container>
        <LiveShopingBackbone />
      </Container>
    )
  }

  return (
    <Container>
      <Column alignItems='center'>
        <Column maxWidth={columnMaxWidth}>
          <Horizontal size={24} />
          <Row
            alignItems='center'
            minHeight='440px'
          >
            <div id='nizza-player'></div>
          </Row>
          <Row padding={'0px 0px 12px 0px'}>
            <Column>
              <Row>
                <Title
                  fontWeight='semibold'
                  headingLevel={isMobile ? 'h5' : 'h3'}
                  text={liveTitle}
                />
              </Row>
              <Row>
                <Title
                  fontWeight='regular'
                  headingLevel={isMobile ? 'h6' : 'h4'}
                  text={liveSubtitle}
                />
              </Row>
            </Column>
          </Row>
        </Column>
        <Row maxWidth={columnMaxWidth}>
          <Shelves
            isMobile={isMobile}
            orientation='horizontal'
            products={products}
          />
        </Row>
      </Column>
    </Container>
  )
}
